<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">道路救援</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="road-rescue">
      <div class="road-rescue-desc">
        <a :href="'tel:' + phoneNumber">
          <div class="road-rescue-callbutton">拨打平台电话{{ phoneNumber }}</div>
        </a>
        <div class="road-rescue_shuoming">
          <div class="road-rescue_title">
            <img class="road-rescue_tipimg" src="/static/newprojecticon/title.png" />
            <div class="road-rescue_tiptitle">救援指引</div>
          </div>
          <div class="road-rescue_tipp">1、道路救援包括城市道路10公里内（高速公路除外）产生的道路救援拖车作业服务费用，如需现场抢修、紧急送油等产生的额外服务需与商家另行协商费用</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httper from '../../api/http';
export default {
  data() {
    return {
      phoneNumber: ""

    }
  },
  created() {
    this.request('getphoneNumber', {
      source: "llcf"
    })
  },
  mounted() {

  },
  methods: {
    pageReturn() {
      this.$router.go(-1)
    },
    pageToIndex() {
      this.$router.push({
        path: "/"
      })
    },
    // 调用接口
    request(type = '', requestData = {}) {
      let that = this
      switch (type) {
        //根据source获取客服电话
        case 'getphoneNumber':
          httper.get('index/tel-phone', requestData, res => {
            if (res.code == 0) {
              console.log("res", res)
              that.phoneNumber = res.data
              // sessionStorage.setItem("phoneNumber", that.phoneNumber)
            }
          })
          break
      }
    }
  }
}
</script>

<style scoped>
/*   body{
    width: 100%;
    height: 100%;

  } */
* {
  margin: 0;
  /* padding: 0; */
}

a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
}

.road-rescue {
  width: 100%;
  background-image: url(../../../static/jiuyuanbg.png);
  background-size: 100% 100%;
  height: 100%;
  position: absolute;
  top: 50px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}

.road-rescue-desc {
  width: 90%;
  margin: 0 20px;
  position: absolute;
  top: 56%;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.road-rescue-callbutton {
  width: 90%;
  margin: 20px;
  height: 46px;
  background: #FD8C00;
  box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
  border-radius: 23px;
  color: #fff;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.road-rescue-callbutton1 {
  width: 90%;
  margin: 20px;
  height: 46px;
  background: linear-gradient(90deg, rgba(252, 183, 50, 1) 0%, rgba(242, 211, 86, 1) 100%);
  box-shadow: 0 4px 5px 2px rgba(234, 110, 86, 0.3);
  border-radius: 23px;
  color: #fff;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.road-rescue_shuoming {
  margin-top: 20px;
  /*    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0 10px;
    border-radius: 10px;
    background-color: #fff;
    padding: 10px;
    font-size: 15px;
    position: absolute;
    top: 45%; */
}

.road-rescue_title {
  /* margin: 10px 0;
    text-align: center;
    font-size: 20px; */
  display: flex;
  align-items: center;
}

.road-rescue_tipimg {
  width: 4px;
  height: 23px;
  margin-right: 10px;
}

.road-rescue_tiptitle {
  font-size: 20px;
}

.road-rescue_tipp {
  font-size: 16px;
  margin-right: 15px;
}

.road-rescue_tipzhu {
  color: red;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/roadRescue.vue